
import Vue, { PropOptions } from 'vue';
import Button from '~/components/builders/Base/Button.vue';
import { BillingAccount, PaymentMethod, Subscription } from '~/services/BillingService';
import { CardItem } from '../types';
import { getPaymentMethodBrandString } from '../util';
import BaseCard from './BaseCard.vue';
import SelectSubscriptionPaymentMethod from './SelectSubscriptionPaymentMethod.vue';

export default Vue.extend({
    name: 'PaymentMethodCard',
    components: {
        BaseCard,
        Button,
        SelectSubscriptionPaymentMethod,
    },
    props: {
        billingAccount: {
            type: Object,
            required: true,
        } as PropOptions<BillingAccount>,
        subscription: {
            type: Object,
            required: true,
        } as PropOptions<Subscription>,
    },
    data() {
        return {
            editing: false,
        };
    },
    computed: {
        paymentMethod(): PaymentMethod | null {
            return this.subscription.paymentMethod || this.billingAccount.defaultPaymentMethod;
        },
        paymentMethodItems(): CardItem[] {
            if (
                this.editing ||
                !this.paymentMethod ||
                !this.paymentMethod.billingDetails ||
                !this.paymentMethod.card
            )
                return [];

            return [
                {
                    label: this.$t('account.paymentMethod.cardInformationLabel').toString(),
                    value: this.$t('account.paymentMethod.cardInformationText', {
                        cardType: getPaymentMethodBrandString(this.paymentMethod.card.brand),
                        lastDigits: this.paymentMethod.card.last4 || '????',
                    }).toString(),
                    html: true,
                },
                {
                    label: this.$t('account.paymentMethod.cardNameLabel').toString(),
                    value: this.paymentMethod.billingDetails.name || 'Unknown',
                },
            ];
        },
    },
    methods: {
        handleEditDone(updated = false) {
            this.editing = false;
            if (updated) this.$emit('update');
        },
    },
});
